import React, { useState, useEffect } from "react";
import Select from "react-select";

const MultiSelectWithCheckbox = ({
  options,
  placeholder,
  onSelectionChange,
  selectedDefault,
  resetTrigger, // Külső trigger a törléshez
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Alapértelmezett kiválasztás beállítása
  useEffect(() => {
    if (selectedDefault && selectedDefault.length > 0) {
      setSelectedOptions(selectedDefault);
    }
  }, [selectedDefault]);

  // Eseménykezelő a kiválasztott elemek módosítására
  const handleChange = (selected) => {
    setSelectedOptions(selected);
    if (onSelectionChange) {
      onSelectionChange(selected);
    }
  };

  // Ha a resetTrigger változik, töröljük a kiválasztott értékeket
  useEffect(() => {
    if (resetTrigger) {
      setSelectedOptions([]); // Töröljük a kiválasztott értékeket
    }
  }, [resetTrigger]); // A resetTrigger változása esetén frissítjük

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (provided) => ({
      ...provided,
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#57cece",
      borderRadius: "4px",
      marginRight: "5px",
      padding: "2px",
      fontSize: "15px",
      fontWeight: "500",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "black", // A címkék színe
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "red", // Az "X" gomb színe
      ":hover": {
        backgroundColor: "transparent", // Hover szín
        color: "red", // Hover szín
      },
      cursor: "pointer", // A pointer kurzor
    }),
  };

  return (
    <Select
      options={options}
      isMulti
      noOptionsMessage={() => "Nincs több választható felhasználó"}
      value={selectedOptions}
      onChange={handleChange}
      styles={customStyles}
      placeholder={placeholder || "Válassz..."}
      isDisabled={options.length === 0}
      closeMenuOnSelect={false}
      key={resetTrigger ? "reset" : "noreset"} // Különböző key, hogy újrarendereljen
    />
  );
};

export default MultiSelectWithCheckbox;
